import {FC} from 'react';

import {ButtonProps as MuiButtonProps} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import {ButtonStyled} from './styles';

export type ButtonProps = MuiButtonProps & {
  shape?: 'rounded' | 'default' | 'rectangle';
  loading?: boolean;
  isInstallmentType?: boolean;
  component?: string;
};

export const Button: FC<ButtonProps> = ({children, loading, ...props}) => {
  return (
    <ButtonStyled size="large" {...props}>
      {loading ? <CircularProgress size={22.5} color="secondary" /> : children}
    </ButtonStyled>
  );
};

export default Button;
